export const BASE_URL = "https://goapi.foxberry.link/v1";
